import { Utils } from '@/app/infrastructures/misc'

export class QueryParamsEntities {
  queryString = ''
  constructor(fields?: any) {
    if (!fields) {
      return
    }
    const queries = []
    for (const [key, value] of Object.entries(fields)) {
      const val: any = value
      if (val) {
        if (!/\d/.test(key)) {
          queries.push(`${Utils.toSnakeCase(key)}=${encodeURIComponent(val)}`)
        } else {
          queries.push(`${key}=${encodeURIComponent(val)}`)
        }
      }
    }
    this.queryString = queries.join('&')
  }
}

export class Report {
  id = 0
  title = ''
  status = ''
  type = ''
  url = ''
  createdAt = ''

  constructor(fields?: Partial<Report>) {
    Object.assign(this, fields)
  }
}

export class Pagination {
  page = 1
  perPage = 10
  total = 0

  constructor(fields?: Partial<Pagination>) {
    Object.assign(this, fields)
  }

  toQuery(): string {
    return new QueryParamsEntities(this).queryString
  }
}

export class ReportData {
  pagination = new Pagination()
  data: Report[] = []
  renderedList: Report[][] = []

  constructor(fields?: Partial<ReportData>) {
    Object.assign(this, fields)
  }
}
